var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"selectionCardList",staticClass:"cz2__scrollbar-hide selection-card-list",class:{
        'cz2__4-grid': _vm.isKiosk && _vm.isAccessoriesStep,
        'cz2__scrollbar-margin': _vm.isKiosk && _vm.hasScrollbar,
        'cz2__kiosk-padding': _vm.isKiosk,
    },attrs:{"role":"radiogroup","aria-labelledby":"step-header-title"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }